import { createFileRoute } from "@tanstack/react-router"
import { ContentMediaPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/content/media"
)({
  component: () => (
    <AuthorizationGate resource={Resource.CONTENT} action={Action.READ}>
      <ContentMediaPage />
    </AuthorizationGate>
  ),
})
